<template>
  <div>
    <b-table :items="pageItems" :fields="fields" class="card-table employee-table">
      <template #cell(num)="{ index }">
        {{ index + 1 + pageOffset }}
      </template>
      <template #cell(name)="data">
        <div class="user-name">
          <app-avatar v-if="data.item.avatar_id" :src="getEmployeeAvatarSrc(data.item)" :alt="data.item.name" />
          {{ data.item.name }}
        </div>
      </template>
      <template #cell(actions)="data">
        <b-btn variant="default btn-xs icon-btn md-btn-flat" title="remove" @click="removeRow(data.index)"
          ><i class="ion ion-md-close"></i
        ></b-btn>
      </template>
    </b-table>
    <AppPager :pager="pager" @change="currentPage = $event - 1" />
  </div>
</template>

<script>
import { getAvatarSrc } from '@/utils/Helpers'
import AppPager from '@/components/shared/AppPager.vue'

export default {
  name: 'EmployeeImportFinalTable',
  components: { AppPager },
  props: {
    items: { type: Array, required: true },
    fields: { type: Array, required: true }
  },
  data() {
    return {
      perPage: 100,
      currentPage: 0
    }
  },
  computed: {
    pager() {
      return {
        currentPage: this.currentPage + 1,
        perPage: this.perPage,
        pageCount: this.pageCount,
        totalCount: this.items.length
      }
    },
    pageCount() {
      return Math.ceil(this.items / this.perPage)
    },
    pageItems() {
      return this.items.slice(this.pageOffset, (this.currentPage + 1) * this.perPage)
    },
    pageOffset() {
      return this.currentPage * this.perPage
    }
  },
  methods: {
    getEmployeeAvatarSrc(employee) {
      return getAvatarSrc(employee.avatar_id, employee.avatar_updated_at)
    },
    removeRow(onPageIndex) {
      const realIndex = this.pageOffset + onPageIndex
      if (this.items[realIndex]) {
        this.items.splice(realIndex, 1)
      }
    }
  }
}
</script>
